module.exports = __webpack_public_path__ + "img/jeni-sandy-audio.fffb3cf4.jpg";